// extracted by mini-css-extract-plugin
module.exports = {"blob":"headline-module--blob--2Murp","scrollright":"headline-module--scrollright--2G9FP"};